// A background picture, made small enough for the server's cap (1.5 MB) before it leaves the phone:
// scaled to at most 1600 px on the long edge and re-encoded, so an ordinary photo lands well under it.
export const MAX_EDGE = 1600
export const MAX_IMAGE_BYTES = 1_500_000

/** The size an image is drawn at: the long edge capped, the shape kept. Pure. */
export const fitEdge = (w: number, h: number, max = MAX_EDGE): { w: number; h: number } => {
  const k = Math.min(1, max / Math.max(w, h, 1))
  return { w: Math.max(1, Math.round(w * k)), h: Math.max(1, Math.round(h * k)) }
}

const toBlob = (c: HTMLCanvasElement, type: string, q: number) =>
  new Promise<Blob | null>((res) => c.toBlob(res, type, q))

/** Scale and re-encode a picked image (webp, else jpeg); tries lower quality until it fits. */
export const downscaleImage = async (file: Blob): Promise<Blob> => {
  const bmp = await createImageBitmap(file)
  const { w, h } = fitEdge(bmp.width, bmp.height)
  const c = document.createElement('canvas')
  c.width = w
  c.height = h
  c.getContext('2d')?.drawImage(bmp, 0, 0, w, h)
  bmp.close()
  for (const q of [0.82, 0.7, 0.55, 0.4]) {
    const b = (await toBlob(c, 'image/webp', q)) ?? (await toBlob(c, 'image/jpeg', q))
    if (b && b.size <= MAX_IMAGE_BYTES) return b
  }
  throw new Error('That picture is too big even after shrinking it')
}
